import React, { useEffect, useRef, useState } from 'react'

import './styles.scss'
import Attachment from 'components/Chat/Attachment'
import { MultiMenuTooltip } from 'components/common'
import { lang } from 'utils/helpers'
import { apiInchat } from 'api'
import { toastMessage } from 'utils/messages'
import inchatActions from 'redux/inchat/actions'
import { useDispatch } from 'react-redux'
import MessageReactions from '../MessageReactions'
import ModalDelete from 'components/ModalDelete'
import MentionsPopup from '../MentionsPopup'
import { removeBrackets, setFormatEditorMentions, setFormatMessagesMentions } from 'components/InChatView/utils'
import { getStaticImage } from 'utils/statics'

const Message = ({ message, showOptions = true, operatorId, showReactions = true, aditionalContent, showAvatar = true, showCountThreads = true, showNumberReactions = true, showSelector = true, onPressSelectEmoji, isChat=true }) => {
  const dispatch = useDispatch()
  const { type, user, text, attachments, _id, conversationId, reactions, userId, isRemoved, isThread, mentions, isPin, isSave, totalThreads = 0 } = message
  const [openModalDelete, setOpenModalDelete] = React.useState(false)
  const [isSubmitDelete, setIsSubmitDelete] = React.useState(false)
  const [isShowOptions, setIsShowOptions] = React.useState(isRemoved ? !isRemoved : showOptions)
  const [ isOpenPopup, setIsOpenPopup ] = useState(false)
  const [operatorInfo, setOperatorInfo] = useState({})
  const isNotOperator = operatorId !== userId

  const toggleBtnRef = useRef(null)

  const messageOptions = (conversationId, messageId) => [
    [{
      label: lang('inchat-create-thread'),
      iconName: 'icon-menu-thread',
      onClick: () => {
        dispatch(inchatActions.onToggleThreads(conversationId, messageId))
      },
      closeMenu: true
    },
    {
      label: isSave ? lang('dashboard_remove') : lang('dashboard_save'),
      iconName: 'icon-menu-saved',
      onClick: async () => {
        if (isSave) {
          try {
            await apiInchat.removeSaveMessage({ id: messageId })
          } catch (error) {
            toastMessage('inchat_error_to_remove_saved', 'error')
          }
        } else {
          try {
            await apiInchat.saveMessage({ conversationId, messageId })
          } catch (error) {
            toastMessage('inchat_error_to_add_saved', 'error')
          }
        }
      },
      closeMenu: true
    },
    // {
    //   label: lang('inchat-remind-me'),
    //   iconName: 'icon-menu-clock',
    //   onClick: () => console.log('Abriendo modal...')
    // },
    // {
    //   label: lang('inchat-copy-link'),
    //   iconName: 'icon-menu-link',
    //   onClick: () => console.log('Abriendo modal...')
    // },
    {
      label: isPin ? lang('inchat-unpin-message-channel') : lang('inchat-pin-message-channel'),
      iconName: 'icon-menu-pin',
      onClick: async () => {
        if (isPin) {
          try {
            await apiInchat.pinRemove({ conversationId, messageId })
          } catch (error) {
            toastMessage(lang('inchat_error_to_remove_pinned'), 'error')
          }
        } else {
          try {
            await apiInchat.pinAdd({ conversationId, messageId })
          } catch (error) {
            toastMessage(lang('inchat_error_to_add_pinned'), 'error')
          }
        }
      },
      closeMenu: true
    },
    {
      label: lang('dashboard_edit'),
      iconName: 'icon-menu-edit',
      onClick: () => {
        dispatch(inchatActions.editMessage({
          message: setFormatEditorMentions(removeBrackets(text), mentions?.usersInfo),
          isThread,
          messageId: _id,
          external: true
        }))
        if(attachments){
          dispatch(inchatActions.editMessageAddAttachments(
            conversationId,
            attachments || [],
            isThread
          ))
        }
        if(mentions?.usersInfo){
          dispatch(inchatActions.updateMentions(conversationId, mentions.usersInfo, isThread))
        }
      },
      closeMenu: true,
      isHidden: isNotOperator
    }],
    [{
      label: lang('dashboard_delete'),
      iconName: 'icon-menu-delete',
      onClick: () => {
        setOpenModalDelete(state => !state)
      },
      closeMenu: true,
      isHidden: isNotOperator
    }],
  ]

  useEffect(() => {
    if (isRemoved) {
      setIsShowOptions(!isRemoved)
    }
  }, [isRemoved])

  useEffect(() => {
    if(mentions && mentions.users.length){
      const mentionSpans = document.querySelectorAll(`.mention-span-message-${_id}`)
      mentionSpans.forEach((span) => {
        const mentionId = span.getAttribute('data-mention-id')
        span.removeEventListener('click', () => handleOpenPopup(mentionId, false))
      })
      mentionSpans.forEach((span) => {
        const mentionId = span.getAttribute('data-mention-id')
        span.addEventListener('click', () => handleOpenPopup(mentionId, true))
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message])

  const handleOpenPopup = (id, open=false) => {
    let userOperator = {}
    if(mentions.usersInfo && id && typeof id === 'string') {
      userOperator = mentions.usersInfo.find(userInfo => userInfo._id === id)
    }
    setIsOpenPopup(() => open)
    setOperatorInfo(() => userOperator)
  }

  const deleteMessage = (messageId, conversationId) => {
    setIsSubmitDelete(true)
    apiInchat.deleteMessage(messageId, { conversationId })
      .then(({ data }) => {
        if(!data){
          messageToast()
        }
        toggleDelete()
      })
      .catch(() => messageToast())
      .finally(() => setIsSubmitDelete(false))
  }

  const toggleDelete = (error) => {
    setOpenModalDelete(state => !state)
  }

  const messageToast = () => {
    toastMessage(lang('error_message_delete'), 'error')
  }

  return (
    <div className={`inchat-message inchat-message--${type} ${!isNotOperator ? 'inchat-message--operator' : ''}`}>
      <div className='inchat-message__header'>
        {(user?.picture && showAvatar) && isNotOperator ?
          <figure className='inchat-message__picture'>
            <img
              src={user.picture}
              alt={`${user.name}
              ${user.lastname}`}
              onError = {event => {
                event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                event.onerror = null
              }}
            />
          </figure>
          : null
        }
        <div className='inchat-message__user-info'>
          <strong>{`${user.name} ${user.lastname}`}</strong>
          { isShowOptions ?
            <div className='container-options'>
              <MultiMenuTooltip
                dotsColor={'#777777'}
                dotsOrientation={'horizontal'}
                options={messageOptions(conversationId, _id)}
                topPosition={0}
                leftPosition={isNotOperator ? 30 : -150}
              />
            </div>
            : null}
        </div>
      </div>
      <div className={`inchat-message__container ${!showAvatar || !isNotOperator ? 'hide-avatar' : ''}`}>
        { showAvatar && <div className='empty' /> }
        <div className='inner'>
          <div className='inchat-message__content'>
            <div className='inchat-message__message-content' ref={toggleBtnRef}>
              <p id={'componenteContainer'} className='inchat-message__text' dangerouslySetInnerHTML={{ __html: isRemoved ? lang(`dashboard_${text}`) : setFormatMessagesMentions(text, mentions, _id) }} />
              { showReactions && !isRemoved ?
                <MessageReactions
                  conversationId={conversationId}
                  messageId={_id}
                  reactions={reactions}
                  showNumberReactions={showNumberReactions}
                  showSelector={showSelector}
                  onPressSelect={onPressSelectEmoji}
                  isChat={isChat}
                  isNotOperator={isNotOperator}
                  isThread={isThread}
                />
                : null}
              { mentions && isOpenPopup ?
                <MentionsPopup
                  operatorInfo={operatorInfo}
                  togglePopup={handleOpenPopup}
                  isOpenPopup={isOpenPopup}
                  toggleBtnRef={toggleBtnRef}
                />
                : null}
              <div className='message-states'>
                {isSave && <img src={getStaticImage('/icons/orange-brand/icon-saved.svg')} alt='saved' title={lang('inchat_title_saved')} />}
                {isPin && <img src={getStaticImage('/icons/orange-brand/icon-pinned.svg')} alt='pinned' title={lang('inchat_title_pinned')}/>}
              </div>
            </div>
          </div>
          {attachments?.length ? (
            <div className='inchat-message__attachments'>
              {attachments.map((attachment, index) => (
                <Attachment
                  key={index}
                  id={attachment.fileId}
                  mimeType={attachment.mimeType}
                  mimeSubtype={attachment.mimeSubtype}
                  url={attachment.url || attachment.urlLong}
                  thumb={attachment.thumb}
                />
              ))}
            </div>
          ) : null}
          {showCountThreads &&
            <div className='inchat-message__message-threads' onClick={() => dispatch(inchatActions.onToggleThreads(conversationId, _id))}>
              {totalThreads > 0 &&
                <span>{`${totalThreads} ${totalThreads === 1 ? lang('dashboard_answer') : lang('inchat_more_threads')}`}
                  <i className='fa fa-chevron-right' />
                </span>}
            </div>}
        </div>
        {aditionalContent && aditionalContent(message)}
      </div>
      <ModalDelete
        isOpen={openModalDelete}
        toggle={toggleDelete}
        header={lang(`message_delete_modal_header`)}
        text1={lang(`message_delete_modal_text_1`)}
        text2={lang(`message_delete_modal_legend`)}
        event={() => deleteMessage(_id, conversationId)}
        isSubmitting={isSubmitDelete}
      />
    </div>
  )
}

export default Message